import React from "react";
import pImage1 from '../../Assets/Project3/PrimaryPart/primary research 1.webp';
import pImage2 from '../../Assets/Project3/PrimaryPart/primary research 2.webp';
import pImage3 from '../../Assets/Project3/PrimaryPart/primary research 3.webp';
import pImage4 from '../../Assets/Project3/PrimaryPart/primary research 4.webp';
import pImage5 from '../../Assets/Project3/PrimaryPart/primary research 5.webp';
import pImage6 from '../../Assets/Project3/PrimaryPart/primary research 6.webp';
import pImage7 from '../../Assets/Project3/PrimaryPart/primary research 7.webp';
import pImage8 from '../../Assets/Project3/PrimaryPart/primary research 8.webp';
import pImage9 from '../../Assets/Project3/PrimaryPart/primary research 9.webp';
import pImage10 from '../../Assets/Project3/PrimaryPart/primary research 10.webp';
import pImage11 from '../../Assets/Project3/PrimaryPart/primary research 11.webp';
import pImage12 from '../../Assets/Project3/PrimaryPart/primary research 12.webp';
import pImage13 from '../../Assets/Project3/PrimaryPart/primary research 13.webp';
import pImage14 from '../../Assets/Project3/PrimaryPart/primary research 14.webp';
import pImage15 from '../../Assets/Project3/PrimaryPart/primary research 15.webp';
import pImage16 from '../../Assets/Project3/PrimaryPart/primary research 16.webp';
import pImage17 from '../../Assets/Project3/PrimaryPart/primary research 17.webp';
import pImage18 from '../../Assets/Project3/PrimaryPart/primary research 18.webp';
import pImage19 from '../../Assets/Project3/PrimaryPart/primary research 19.webp';
import pImage20 from '../../Assets/Project3/PrimaryPart/primary research 20.webp';

const PrimaryPart = () => {
    return (
        <div className="Primary-container">
            <h1>Primary Research</h1>

            <div className="Primary-images-grid">
            <img src={pImage1} className="Primary-grid-image" />
            <img src={pImage2} className="Primary-grid-image" />
            <img src={pImage3} className="Primary-grid-image" />
            <img src={pImage4} className="Primary-grid-image" />
            </div>

            <h1>User Personna</h1>
            <div className="Primary-images-grid">
            <img src={pImage5} className="Primary-grid-image" />
            <img src={pImage6} className="Primary-grid-image" />
            <img src={pImage7} className="Primary-grid-image" />
            <img src={pImage8} className="Primary-grid-image" />
            </div>

            <h1>Photo Journaling</h1>
            <div className="Primary-images-grid">
            <img src={pImage9} className="Primary-grid-image" />
            <img src={pImage10} className="Primary-grid-image" />
            <img src={pImage11} className="Primary-grid-image" />
            <img src={pImage12} className="Primary-grid-image" />
            <img src={pImage13} className="Primary-grid-image" />
            <img src={pImage14} className="Primary-grid-image" />
            <img src={pImage15} className="Primary-grid-image" />
            <img src={pImage16} className="Primary-grid-image" />
            <img src={pImage17} className="Primary-grid-image" />
            <img src={pImage18} className="Primary-grid-image" />
            </div>

            <h1>User Journey</h1>
            <div className="Primary-images-grid">
            <img src={pImage19} className="Primary-grid-image" />
            <img src={pImage20} className="Primary-grid-image" />
            </div>
        </div>
    );
};

export default PrimaryPart;